import _isBoolean from 'lodash/isBoolean';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';

/**
 * PLA-9811: lodash treats a boolean as empty (`_isEmpty(true) === true`), so a change whose
 * values were booleans read as "nothing changed". The audit row lost the key and, when it was
 * the only key, the whole row was dropped before render. `false` and `0` are values; only
 * null/undefined and empty strings/objects/arrays are absent.
 */
export const hasValue = (value: unknown): boolean =>
  _isBoolean(value) || _isNumber(value) ? true : !_isEmpty(value);

/** True when either side of an audit `[old, new]` pair carries a value. */
export const hasAnyValue = (pair: unknown): boolean =>
  Array.isArray(pair) ? pair.some(hasValue) : hasValue(pair);
